export default function allElementsIn(arr1: any[], arr2: any[], key: string = 'id') {
  return arr1.every((item) => arr2.some((item2) => item[key] === item2[key]));
}
